module.exports = __webpack_public_path__ + "static/img/product-banner.4575ae9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-banner.png
// module id = Ya1G
// module chunks = 1